import { useQuery } from "@tanstack/solid-query";
import { Component, createSignal, For } from "solid-js";

import gqlClient from "../../schema/gqlAuthorizedRequest.js";
import { graphql } from "../../schema/index.js";
import { BooleanValueDisplay } from "../common/BooleanValueDisplay.jsx";
import { Button } from "../common/Button.jsx";
import DataLoadingSwitch from "../common/DataLoadingSwitch.jsx";
import { DateValue } from "../common/DateValue.jsx";
import { Layout } from "../common/Layout.jsx";
import { PageHeader } from "../common/PageHeader.jsx";
import { Table, Td, Th, Tr } from "../common/TableComponents.jsx";
import { DbsPositionCreateModal } from "./DbsPositionCreateModal.jsx";

const getDbsCheckPositionsQueryGql = graphql(`
  query getDbsCheckPositionsForAdmin {
    getDbsCheckPositions {
      id
      name
      externalId
      workingWithVulnerableAdultsEntitlement
      requestAdultFirst
      workingAtHome
      workingWithChildrenEntitlement
      createdAt
      updatedAt
    }
  }
`);

export const DbsPositions: Component = () => {
  const [showCreateDbsPositionModal, setShowCreateDbsPositionModal] =
    createSignal(false);

  const positions = useQuery(() => ({
    queryKey: ["dbs-positions"],
    queryFn: async () => gqlClient.request(getDbsCheckPositionsQueryGql),
  }));

  return (
    <Layout class="space-y-6">
      <DbsPositionCreateModal
        show={showCreateDbsPositionModal()}
        onClose={() => {
          setShowCreateDbsPositionModal(false);
          positions.refetch();
        }}
      />

      <PageHeader parentTitle="Platform admin" title="DBS check positions">
        <Button onClick={() => setShowCreateDbsPositionModal(true)}>
          Create DBS check position
        </Button>
      </PageHeader>

      <Table class="overflow-visible bg-white">
        <thead>
          <tr>
            <Th>Name</Th>
            <Th>External ID</Th>
            <Th>Working with Children</Th>
            <Th>Working with Vulnerable Adults</Th>
            <Th>Request Adult First</Th>
            <Th>Working at Home</Th>
            <Th>Created At</Th>
            <Th>Updated At</Th>
          </tr>
        </thead>

        <tbody>
          <DataLoadingSwitch
            loader={positions}
            loadingContent={
              <Tr>
                <Td colspan={8} class="text-center">
                  Loading...
                </Td>
              </Tr>
            }
          >
            <For each={positions.data?.getDbsCheckPositions}>
              {(position) => (
                <Tr>
                  <Td>{position?.name}</Td>
                  <Td>{position?.externalId}</Td>
                  <Td>
                    <BooleanValueDisplay
                      value={position?.workingWithChildrenEntitlement}
                    />
                  </Td>
                  <Td>
                    <BooleanValueDisplay
                      value={position?.workingWithVulnerableAdultsEntitlement}
                    />
                  </Td>
                  <Td>
                    <BooleanValueDisplay value={position?.requestAdultFirst} />
                  </Td>
                  <Td>
                    <BooleanValueDisplay value={position?.workingAtHome} />
                  </Td>
                  <Td>
                    <DateValue date={position?.createdAt} />
                  </Td>
                  <Td>
                    <DateValue date={position?.updatedAt} />
                  </Td>
                </Tr>
              )}
            </For>
          </DataLoadingSwitch>
        </tbody>
      </Table>
    </Layout>
  );
};
